import authsession from './authsession';

const logProduct = ( api, data, setLogData, notifyError, notifyInfo ) => {

  
    api({
        method: 'post',
        headers: { 'Authorization': authsession() },
        url: 'logsc.php?fun=read&lokacija=proizvodi',
        data: data,
    })
        .then((response) => {

            if (response.data.uspesno) {
                setLogData(response.data);
            } else if (response.data.greska) {
                notifyError(response.data.greska);
            } else if (response.data.info) {
                notifyInfo(response.data.info);
            }
        })

}

export default logProduct